import React, { useState, useEffect, useContext, useRef } from 'react';
import { AdminContext } from '../../hooks';
import axios from 'axios';

function NORMALISE(str) {
  return str
    .normalize('NFD')                   // decompose accented chars e.g. é -> e +  ́
    .replace(/[\u0300-\u036f]/g, '')    // strip accent marks
    .replace(/[^a-zA-Z0-9 ]/g, '')     // remove anything not latin, number, or space
    .toUpperCase()
    .trim();
}

function A({className, onClick=()=>{},children, disabled}) {
  if (disabled) return <span>{children}</span>
  return <span className={`A ${className}`} onClick={onClick}>{children}</span>
}

function AreYouSure({className, onClick=()=>{},children, disabled}) {
  let [clicked, setClicked] = useState(false);
  let [loading, setLoading] = useState(false);
  let timeout = useRef();
  if (loading) return <span className={className}><i>Wait...</i></span>
  if (clicked) return <span className={className}>Sure? <A disabled={disabled} onClick={async ()=>{
    setLoading(true);
    await onClick();
    setLoading(false);
    setClicked(false);
    clearTimeout(timeout.current);
  }}>Yes</A></span>
  return <A className={className} disabled={disabled} onClick={()=>{
    setClicked(true);
    timeout.current = setTimeout(()=>setClicked(false),1500);
  }}>{children}</A>
}

function EditSong({song = {title:"",artist:"",tabs:"",_id:""}}) {
  let [title, setTitle] = useState(song.title);
  let [artist, setArtist] = useState(song.artist);
  let [tabs, setTabs] = useState(song.tabs);
  let [disabled, setDisabled] = useState(false);

  useEffect(()=>{
    if (song._id && !song.tabs) {
      (async()=>{
        setDisabled(true);
        let {data} = await axios.get("https://kaisboatfund.co.uk/api/kaipad/song-data?_id="+song._id);
        setTabs(data.tabs)
        setDisabled(false);
      })()
    }
  },[])

  return <div>
    <div className="split dynamic">
      <div className="thin">
        <div>
          <h4>Title: </h4>
          <input type="text" value={title} disabled={disabled} onChange={(e) => setTitle(e.target.value)} />
        </div>
        <div>
          <h4>Artist: </h4>
          <input type="text" value={artist} disabled={disabled} onChange={(e) => setArtist(e.target.value)} />
        </div>
        <div><ul>
          <li><AreYouSure disabled={disabled} onClick={async ()=>{
            setDisabled(true);
            if (song._id) {
              await axios.post("https://kaisboatfund.co.uk/api/kaipad/edit-song", {song: {title, artist, tabs, _id: song._id}});
            } else {
              await axios.post("https://kaisboatfund.co.uk/api/kaipad/add-song", {song: {title, artist, tabs, page:11, tabUrl: "https://kaisboatfund.co.uk/"}});
            }
            setDisabled(false);
          }}>Save</AreYouSure></li>
          {song._id?<li><AreYouSure disabled={disabled} onClick={async ()=>{
            setDisabled(true);
            await axios.get("https://kaisboatfund.co.uk/api/kaipad/delete-song?_id="+song._id);
            setDisabled(false);
          }}>Delete</AreYouSure></li>:null}
        </ul></div>
      </div>
      <div>
        <textarea
          className="marB"
          disabled={disabled}
          value={tabs}
          onChange={(e) => setTabs(e.target.value)}
        />
      </div>
    </div>
  </div>
}

function SearchSong({callback}) {
  let [input, setInput] = useState("");
  let [results, setResults] = useState();
  let [loadingResults, setLoadingResults] = useState(false);
  let [song, setSong] = useState();

  if (song) return <EditSong song={song}/>

  return <div className="Songs">
    <div className="thin autoMargins">
      <h4>Song name:</h4>
      <input className="marB" type="text" value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={async (e) => {
        if (e.key === "Enter" && input.length > 0) {
          setLoadingResults(true);
          let {data} = await axios.get("https://kaisboatfund.co.uk/api/kaipad/search-song?q="+NORMALISE(input).replace(/ /g, "%20"));
          setLoadingResults(false);
          let {count, records} = data;
          setResults(records.map(r=>({title:r[0],artist:r[1],_id:r[2]})));
        }
      }}/>
      {loadingResults ? <div><i>Loading...</i></div> : results ? results.length == 0 ? <div><i>There is nothing here...</i></div> : <ul className="padB">
        {results.map(r=><li key={r._id}><A onClick={()=>callback?callback(r):setSong(r)}><div className="splitV padB"><div>{r.title}</div><div className="small">{r.artist}</div></div></A></li>)}
      </ul> : null}
    </div>
  </div>
}

function RecentlyViewed({}) {
  let [song, setSong] = useState();
  useEffect(()=>{(async()=>{
    let {data} = await axios.get("https://kaisboatfund.co.uk/api/kaipad/recently-viewed");
    setSong(data);
  })()},[])
  if (!song) return <div className="split"><div className="thin"/><div><textarea className="marB" disabled={true}/></div></div>;
  return <EditSong song={song}/>
}

function List({hello}) {
  let [list, setList] = useState([]);
  let [popup, setPopup] = useState(false);
  let [disabled, setDisabled] = useState(true);

  useEffect(()=>{(async()=>{
    let {data} = await axios.get(`https://kaisboatfund.co.uk/api/kaipad/${hello}`);
    setList(data.records.map(r=>({title:r[0],artist:r[1],_id:r[2]})));
    setDisabled(false);
  })()},[])

  function save() {
    axios.post(`https://kaisboatfund.co.uk/api/kaipad/update-${hello}`,list.map(l=>[l.title,l.artist,l._id]));
  }

  function swap(a,b) {
    let c = list[a];
    list[a] = list[b];
    list[b] = c;
    setList([...list]);
    save();
  }

  return <div>
    {popup?<div className="Popup"><div className="X"><A onClick={()=>setPopup(false)}>X</A></div><SearchSong callback={song=>{
      list.push(song);
      setList([...list]);
      setPopup(false);
      save();
    }}/></div>:null}
    <ul>
      {list.map((song, i)=><li key={song._id}><div className="splitV padB"><div>
        {song.title}
        {i > 0 ? <A className="small marL" onClick={()=>swap(i, i-1)}>up</A> : null}
        {i < list.length-1 ? <A className="small marL" onClick={()=>swap(i, i+1)}>down</A> : null}
        <A className="small marL" onClick={()=>{
          list.splice(i,1);
          setList([...list]);
          save();
        }}>delete</A>
      </div><div className="small">{song.artist}</div></div></li>)}
      {list.length < 48 ? <li><A disabled={disabled || popup} onClick={()=>setPopup(true)}>Add song...</A></li> : null}
    </ul>
  </div>
}

function Playlist({}) {
  return <List hello={"playlist"}/>
}

function Favourites({}) {
  return <List hello={"favourites"}/>
}

function Logo({}) {
  return <div className="alignCentre"><svg viewBox="0 0 458.2 297.6" className="logo"><path d="M157.8,187.1c0.4-20.6,14.4-43.9,20.7-66.7c6.7-24.2,3.3-44.2-7.9-65.7c-4.1-7.9-20.3-15.6-25.8,5.6c-9.8,37.5-28.6,59.9-49.4,86.4C87.1,157.3,97,167,106.5,166c5.7-0.6,10.6-9.9,13-14.4c4.6-8.7,9.5-21.8,15.4-25.2s19.9-1.2,20.7,9s-24.4,33.4-22.9,53.7S157.5,207.7,157.8,187.1z M147.2,102.7c-1.6-6.7,7.2-21.2,14.6-19.2c6.6,1.8,6,21.2,1.1,25.3C158.1,112.8,148.9,109.4,147.2,102.7z"/><path d="M241.7,256.8c-9.1-2.5-19.1-4.1-28.6-7c-9.5-2.9-14.4-11.6-17.2-21.1c-6.3-21.7-7.3-45.7,4.9-68.9c13-24.9,28.6-47.2,29.2-75c0.3-13-3.1-19.9-8.9-32c-6.1-12.5,3.1-15.1,10.9-13.6c2.3,0.5,4.6,0.9,6.9,1.4c16.2,3.3,10.5-35.1-18.4-31.9c-28.7,3.1-46.7-0.2-72.1-7.9c-21.1-6.5-27.5,32.4,5.4,29.3c8.1-0.8,13.3-0.2,21.2,0.7c8.3,1,14.4,6.8,19.2,13.7c18.1,25.5,22.9,55.7,4.3,89.5c-8.7,15.8-27.1,44.6-25.9,83.4c0.5,17.6-10.2,15-15.7,13.5c-9-2.5-18-8.2-25.8-13.3c-20-12.9-31.2,29.6-10.8,34.1c45,9.8,80.8,23.6,120.3,43.9C263.9,307.5,270.9,264.9,241.7,256.8z"/><path d="M350.6,34.7c-13.8-11.5-37.6,1.7-66.4,14.4c-16.5,7.3-30,12-29.3,27.7c2.2,46.1-37.8,77.4-45.2,121c-4.3,25.4,27.2,28.5,27.1,4.1c-0.1-24.1,2.1-41.1,13.9-59.9c5.2-8.3,13.7-14.2,23.4-15.8C357.2,111.9,369.1,50.1,350.6,34.7zM269.3,99.5c-3.2-8.4,17.1-34.7,32.1-38.3c11.8-2.8,20.9,5.5,15.4,19.4C309.1,99.9,272.8,108.6,269.3,99.5z"/><path d="M332.9,139.4c2.5-14.2-15.2-10.1-24.4-1.4c-16.5,15.9-24.3,22.5-39.4,39.8c-20.5,23.7-25,42.5-25,55.5c0,19.1,30.4,24.1,28.3,6.4c-1.4-11.8-7.2-24.2-0.7-29.5s34.4,1.2,42.2,10.4c8.3,9.8,1.3,23.4,10.3,38c7.9,13,37.8,15,30-0.3c-10.6-20.8-24.4-43.2-26-66.9C327,171.5,329.3,159.6,332.9,139.4z M283.9,188.9c-0.1-10.3,15.5-27.5,21.1-26.8c6,0.8,6.5,25.9,0.3,32.2C300.3,199.6,284,199.2,283.9,188.9z"/><path d="M458,137.1c-2.3-26.1-56.7-60.8-69-71.6c-14.8-13-21.9,2.3-21.1,15.4c2.6,43-7.6,68.2-21.4,114.8c-3.7,12.5,6.3,20.7,21.5,18.9c18-2.2,42.2-10.9,58.2-24C441.4,178,460,159.3,458,137.1z M374.8,170.7c2.6-20.7,3.6-31.2,8.3-47.6c2.4-8.3,7.7-11.4,12.5-9.9c13.8,4.3,29.4,22.8,31,36.4c2,17-9.2,28.2-30.2,35.3C385.2,188.7,373,185.5,374.8,170.7z"/><path d="M101.7,195.7c-6.1-25.1-46.5-33.2-48.8-49.5s64.9-63.8,69.4-93.1C125,35.4,101.7,18.6,91,39.2c-7.5,14.5-37.5,88.6-46.9,82.9c-10.4-6.4,0.4-31.1-4.2-43.2C32.8,60.3,7,63,2.3,78.4c-9.1,30,11.2,57.5,17.2,83c5.9,25,14,49.6,15.2,75.8c0.3,5.7,3.5,10.2,9.2,9.1c4.9-1,10.8-7.5,10.9-13.6c0.1-18.2-9.2-50.6-3.2-54.7c6-4.1,22.4,29.2,33,38.6C96.6,227.3,104.2,206,101.7,195.7z"/></svg></div>;
}

function DebouncedInput({ onChange, delay = 1000, value, setValue, ...props }) {
  useEffect(() => {
    let t = setTimeout(() => onChange(value), delay);
    return () => clearTimeout(t);
  }, [value, delay, onChange]);
  return (
    <input
      type="text"
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

function EditBook({book={}, goBack}) {
  let [title, setTitle] = useState(book.title);
  let [author, setAuthor] = useState(book.author);
  let [chapters, setChapters] = useState(book.chapters);
  let [cover, setCover] = useState(book.cover);
  let [dithered, setDithered] = useState();
  let [disabled, setDisabled] = useState(false);
  let [uploading, setUploading] = useState(!!book.chapters)
  let [done, setDone] = useState(false);
  let [printing, setPrinting] = useState();

  useEffect(()=>{(async()=>{
    if (!uploading) {
      let {data} = await axios.get("https://kaisboatfund.co.uk/api/kaipad/book?_id="+book._id);
      setChapters(data.chapters);
    }
  })()},[]);

  if (done) return <ArrangeLibrary/>

  if (!chapters) return <div className="PleaseWait"><i>Please wait...</i></div>
  return <div>
    {printing?<PrintPopup _id={printing} ok={()=>{
      setDisabled(false);
      setPrinting();
      if (goBack) {
        goBack({ ...book, chapters, title, author});
      } else {
        setDone(true);
      }
    }}/>:null}
    {uploading ? <EditCover disabled={disabled} cover={cover} setDithered={setDithered}/> : null}
    <div className="inputSplit">
      <DebouncedInput value={title} setValue={setTitle} onChange={()=>axios.post("https://kaisboatfund.co.uk/api/kaipad/edit-book", {_id:book._id, title})}/>
      <DebouncedInput value={author} setValue={setAuthor} onChange={()=>axios.post("https://kaisboatfund.co.uk/api/kaipad/edit-book", {_id:book._id, author})}/>
    </div>
    <div className="alignCentre">
      <Chapters disabled={disabled} chapters={chapters} delet={i=>{
        chapters.splice(i,1);
        setChapters([...chapters]);
      }} change={(i,c)=>{
        chapters[i] = c;
        setChapters([...chapters]);
      }}/>
    </div>
    <div className="marB alignCentre">
      {uploading ? <AreYouSure disabled={disabled} onClick={async ()=>{
        setDisabled(true);
        let {data} = await axios.post("https://kaisboatfund.co.uk/api/kaipad/upload-book", {...book, chapters, dithered, title, author});
        setPrinting(data);
        // setDisabled(false);
        // setDone(true);
      }}>Upload</AreYouSure> : <AreYouSure disabled={disabled} onClick={async ()=>{
        setDisabled(true);
        let {data} = await axios.post("https://kaisboatfund.co.uk/api/kaipad/edit-book", {_id:book._id, chapters});
        setPrinting(data);
        // setDisabled(false);
        // goBack({ ...book, chapters, title, author});
      }}>Save</AreYouSure>}
    </div>
  </div>
}

function Chapter({ disabled, chapter, change }) {
  let [title, setTitle] = useState(chapter.title);
  let [text, setText] = useState(chapter.text);

  useEffect(() => {
    let timeout = setTimeout(() => {
      change({ ...chapter, title, text });
    }, 1000);

    return () => clearTimeout(timeout);
  }, [title, text]);

  return (
    <div className="Chapter">
      <input
        type="text"
        value={title}
        onChange={e => setTitle(e.target.value)}
        disabled={disabled}
      />
      <textarea
        value={text}
        onChange={e => setText(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
}

function Chapters({disabled, chapters, change, delet}) {
  return <div className="Chapters">
    {chapters.map((c, i)=><div key={chapters.length +' '+i}>
      <Chapter disabled={disabled} chapter={c} change={c=>change(i,c)}/>
      <AreYouSure onClick={()=>delet(i)}>Delete chapter</AreYouSure>
    </div>)}
  </div>
}

function dither(imageData, width, height) {
  let data = imageData.data;
  let getIndex = (x, y) => (y * width + x) * 4;
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      let i = getIndex(x, y);
      let oldPixel = data[i];
      let newPixel = oldPixel < 128 ? 0 : 255;
      let error = oldPixel - newPixel;
      data[i] = data[i + 1] = data[i + 2] = newPixel;
      let addError = (dx, dy, factor) => {
        let nx = x + dx;
        let ny = y + dy;
        if (nx < 0 || nx >= width || ny < 0 || ny >= height) return;
        let ni = getIndex(nx, ny);
        data[ni] += error * factor;
        data[ni + 1] += error * factor;
        data[ni + 2] += error * factor;
      };
      addError(1, 0, 7 / 16);
      addError(-1, 1, 3 / 16);
      addError(0, 1, 5 / 16);
      addError(1, 1, 1 / 16);
    }
  }
  for (let i = 0; i < imageData.data.length; i += 4) imageData.data[i + 3] = 255;
  return imageData;
}

function Slider({disabled, value, setValue, children}) {
  let [display, setDisplay] = useState(value);
  let ref = useRef(null);
  let startY = useRef(0);
  let startX = useRef(0);
  let startValue = useRef(value);
  let currentValue = useRef(value)
  let dragging = useRef(false);

  useEffect(() => {
    let mousemove = (e) => {
      if (!dragging.current) return;
      let dy = startY.current - e.clientY;
      let dx = e.clientX - startX.current;
      let d = Math.abs(dy) > Math.abs(dx) ? dy : dx;
      let newValue = Math.min(1,Math.max(0, startValue.current + d/100));
      currentValue.current = newValue;
      setDisplay(newValue);
    };
    let mouseup = () => {
      dragging.current = false;
      setValue(currentValue.current)
    }
    window.addEventListener("mousemove", mousemove);
    window.addEventListener("mouseup", mouseup);
    return () => {
      window.removeEventListener("mousemove", mousemove);
      window.removeEventListener("mouseup", mouseup);
    };
  }, []);

  return (
    <span className="Slider" ref={ref} onMouseDown={disabled ? null : (e) => {
      dragging.current = true;
      startY.current = e.clientY;
      startX.current = e.clientX;
      startValue.current = value;
    }}>{children?children:null} {Math.round(display * 100)}</span>
  );
}

function packBits(imageData, width, height) {
  const numPixels = width * height;
  let packed = new Uint8Array(Math.ceil(numPixels / 8));
  for (let i = 0; i < numPixels; i++) {
    const r = imageData.data[i * 4]; // R channel of pixel i
    if (r > 127) packed[i >> 3] |= (1 << (7 - (i % 8)));
  }
  let binary = '';
  for (let i = 0; i < packed.length; i++) binary += String.fromCharCode(packed[i]);
  return btoa(binary);
}

function EditCover({ cover, disabled, setDithered }) {
  let canvasRef = useRef(null);
  let tempRef = useRef(null);
  let [red, setRed] = useState(0.5);
  let [green, setGreen] = useState(0.5);
  let [blue, setBlue] = useState(0.5);
  let [contrast, setContrast] = useState(0.5);
  let [loaded, setLoaded] = useState(false);

  let W = 130;
  let H = 180;

  useEffect(() => {
    let canvas = canvasRef.current;
    let ctx = canvas.getContext("2d");
    let img = new Image();
    let base64 = btoa(new Uint8Array(cover.data.data).reduce((data, byte) => data + String.fromCharCode(byte),""));

    img.onload = () => {
      let temp = tempRef.current;
      let tctx = temp.getContext("2d");
      tctx.fillStyle = "white";
      tctx.fillRect(0, 0, temp.width, temp.height);
      let iw = img.width, ih = img.height;
      let scale = Math.min(W / iw, H / ih);
      let w = iw * scale, h = ih * scale;
      temp.width = w; temp.height = h;
      canvas.width = w; canvas.height = h;
      tctx.drawImage(img, 0, 0, w, h);
      setLoaded(true);
    };

    img.src = `data:${cover.mimeType};base64,${base64}`;
  }, [cover]);

  useEffect(()=>{
    let ctx = canvasRef.current.getContext("2d");
    let temp = tempRef.current;
    let tctx = temp.getContext("2d");
    let imageData = tctx.getImageData(0, 0, temp.width, temp.height);
    let data = imageData.data;
    for (let i = 0; i < data.length; i += 4) {
      let r = data[i], g = data[i + 1], b = data[i + 2];
      r *= red*2; g *= green*2; b *= blue*2;
      let gray = 0.299 * r + 0.587 * g + 0.114 * b;
      gray = (gray - 128) * ((contrast - 0.5) * 2 + 1) + 128;
      data[i] = data[i + 1] = data[i + 2] = gray;
    }
    let dithered = dither(imageData, temp.width, temp.height);
    ctx.putImageData(dithered, 0, 0);
    
    setDithered({data: packBits(dithered, temp.width, temp.height), width: temp.width, height: temp.height});
  },[red, green, blue, contrast, loaded]);

  return <div className="EditCover">
    <canvas ref={tempRef} />
    <div className="sliders">
      <div><Slider disabled={disabled} value={red} setValue={setRed} >Red:</Slider></div>
      <div><Slider disabled={disabled} value={green} setValue={setGreen} >Green:</Slider></div>
      <div><Slider disabled={disabled} value={blue} setValue={setBlue} >Blue:</Slider></div>
      <div><Slider disabled={disabled} value={contrast} setValue={setContrast} >Contrast:</Slider></div>
    </div>
    <canvas ref={canvasRef} />
  </div>;
}

function UploadBook({}) {
  let [file, setFile] = useState();
  let [book, setBook] = useState();
  let [loading, setLoading] = useState(false);

  let upload = async (selectedFile) => {
    setLoading(true);
    let formData = new FormData();
    formData.append("epub", selectedFile);
    let { data } = await axios.post("https://kaisboatfund.co.uk/api/kaipad/upload-epub", formData,{ headers: { "Content-Type": "multipart/form-data" } });
    setBook(data);
    setLoading(false);
  };

  if (book) return <EditBook book={book}/>

  return <div className="alignCentre">
    <input
      id="file"
      type="file"
      accept=".epub"
      style={{ display: "none" }}
      onChange={(e) => {
        let f = e.target.files[0];
        setFile(f);
        if (f) upload(f);
      }}
    />

    <label htmlFor="file" className="uploadButton">
      {loading ? "Please wait..." : "Upload book"}
    </label>
  </div>
}

function useDontRunTheFirstTime(effect, deps, howManyTimes = 1) {
  let firstRun = useRef(0);
  useEffect(() => {
    if (firstRun.current < howManyTimes) {
      firstRun.current++;
      return
    }
    return effect();
  }, deps);
}

function ArrangeLibrary() {
  let [books, setBooks] = useState([]);
  let [piles, setPiles] = useState(Array.from({ length: 6 }, () => []));
  let [popup, setPopup] = useState(-1);

  useEffect(()=>{(async()=>{
    let {data} = await axios.get('https://kaisboatfund.co.uk/api/kaipad/library');
    let {books, piles} = data;
    setBooks(books);
    setPiles(piles);
  })()},[]);

  useDontRunTheFirstTime(() => {
    axios.post('https://kaisboatfund.co.uk/api/kaipad/book-piles', piles.map(p=>p.map(b=>b._id)) );
  }, [piles], 2);
 
  let handleDragStart = (e, book, from) => {
    e.dataTransfer.setData("id", book._id);
    e.dataTransfer.setData("from", from);
    e.dataTransfer.setDragImage(e.target, 15, 15);
  };
 
  let removeFrom = (id, from) => {
    if (from === "books") {
      setBooks(p => p.filter(b => b._id !== id));
    } else {
      let idx = Number(from);
      setPiles(b => {
        let copy = b.map(pile => pile.slice());
        copy[idx] = copy[idx].filter(b => b._id !== id);
        return copy;
      });
    }
  }
  
  let handleDropPile = (e, pileIndex) => {
    e.preventDefault();
    let id = e.dataTransfer.getData("id");
    let from = e.dataTransfer.getData("from");
    if (from === String(pileIndex)) return;
    if (piles[pileIndex].length >= 4) return;
    removeFrom(id, from);
    let book = books.find(b => b._id === id) || piles.flat().find(b => b._id === id);
    if (!book) return;
    setPiles(b => {
      let copy = b.map(p => p.slice());
      copy[pileIndex] = [...copy[pileIndex], book];
      return copy;
    });
  }
  
  let handleDropBooks = (e) => {
    e.preventDefault();
    let id = e.dataTransfer.getData("id");
    let from = e.dataTransfer.getData("from");
    if (from === "books") return;
    removeFrom(id, from);
    let book = piles.flat().find(b => b._id === id);
    if (!book) return;
    setBooks(p => [...p, book]);
  }
 
  return <div className="ViewLibrary">
    {popup>=0?<div className="Popup"><div className="X"><A onClick={()=>setPopup(-1)}>X</A></div><ul>{piles[popup].map(p=><li className="marB" key={p._id}><div>{p.title}</div><div className="small">{p.author}</div></li>)}</ul></div>:null}
    <div className="centreFlex">
      <div className="piles">
      {piles.map((pile, i) => <div className={`pile ${pile.length == 0 ? 'empty' : ''}`} key={i} onClick={pile.length == 0 ? null:()=>setPopup(i)} onDragOver={(e) => e.preventDefault()} onDrop={(e) => handleDropPile(e, i)}>
        {pile.map(b => <img key={b._id} src={`https://kaisboatfund.co.uk/api/kaipad/book-cover/${b.cover.path}`} title={`${b.title} — ${b.author}`} draggable onDragStart={popup>=0?null:(e) => handleDragStart(e, b, String(i))}/>)}
      </div>)}
    </div>
    </div>
    
    <div className="bookPile" onDragOver={(e) => e.preventDefault()} onDrop={handleDropBooks}>
      {books.map(b => <img key={b._id} src={`https://kaisboatfund.co.uk/api/kaipad/book-cover/${b.cover.path}`} title={`${b.title} — ${b.author}`} draggable onDragStart={popup>=0?null:(e) => handleDragStart(e, b, "books")}/>)}
    </div>
  </div>
}

function PrintPopup({fin, _id, ok}) {
  let [error, setError] = useState();
  let [success, setSuccess] = useState();
  let [pages, setPages] = useState(0);
  useEffect(()=>{(async()=>{
    let {data} = await axios.get("https://kaisboatfund.co.uk/api/kaipad/reprint-book?_id=" + _id);
    let interval = setInterval(async () => {
      let { data } = await axios.get("https://kaisboatfund.co.uk/api/kaipad/printing?_id=" + _id);
      if (data.pages) setPages(data.pages);
      if (data.error) {
        setError(data.error);
        clearInterval(interval);
      }
      if (data.success) {
        setSuccess(true);
        clearInterval(interval);
      }
    }, 1111);
    return () => clearInterval(interval);
  })()},[]);

  return <div className="Popup">{fin?<div className="X"><A onClick={fin}>X</A></div>:null}
    <div>
      {error ? <div><div className="xxlarge">Error!</div><div>{error[0]}</div><div className='small'><pre>{error[1]}</pre></div></div> : success ? <div><div className="xxlarge">Finished!</div><div>There are {pages} pages</div><div><A onClick={fin?fin:ok}>OK!</A></div></div> : `Printing page ${pages}...`}
    </div>
  </div>

}

function EditBooks({}) {
  let [books, setBooks] = useState([]);
  let [edit, setEdit] = useState(-1);
  let [reprint, setReprint] = useState();
  let [loading, setLoading] = useState(false);
  useEffect(()=>{(async()=>{
    let {data} = await axios.get('https://kaisboatfund.co.uk/api/kaipad/colour-books');
    setBooks(data);
  })()},[])
  if (edit >=0) return <EditBook book={books[edit]} goBack={b=>{
    books[edit].title = b.title;
    books[edit].author = b.author;
    setBooks([...books]);
    setEdit(-1);
  }}/>
  return <div className="EditBooks">
    {reprint ? <PrintPopup _id={reprint} fin={()=>setReprint()}/> : null}
    <ul>{books.map((b,i)=><div className="Book"><div className="Img">
      <img src={`https://kaisboatfund.co.uk/api/kaipad/book-cover/${b.cover.path}`}/>
    </div><div className="Details">
      <div>{b.title}</div>
      <div className="small">{b.author}</div>
      <div className="Buttons">
        <A disabled={loading||reprint} onClick={()=>setEdit(i)}>Edit</A>
        <AreYouSure disabled={loading || reprint} onClick={async ()=>{
          setLoading(true);
          await axios.get("https://kaisboatfund.co.uk/api/kaipad/delete-book?_id="+b._id);
          books.splice(i,1);
          setBooks([...books]);
          setLoading(false);
        }}>Delete</AreYouSure>
        <AreYouSure disabled={loading||reprint} onClick={async ()=>{
          setReprint(b._id);
        }}>Reprint</AreYouSure>
      </div>
    </div></div>)}</ul>
  </div>
}

function Kaipad() {
    let pages = [
        ["Songs", [
            ["Search song", SearchSong], 
            ["Playlist", Playlist], 
            ["Favourites", Favourites], 
            ["Recently viewed", RecentlyViewed], 
            ["Add song", EditSong]]], 
        ["Books", [
            ["Arrange library", ArrangeLibrary],
            ["Edit books", EditBooks],
            ["Upload book", UploadBook],
        ]]];
    let [page, setPage] = useState();
    let [Render, setRender] = useState();

    let getBg = useRef();
    
    useEffect(() => {
        setBackgroundColour("Kaipad");
        return () => setBackgroundColour(false);
    }, [])

    let { admin, setBackgroundColour } = useContext(AdminContext);
  
    return <div className="Kaipad" ref={getBg}>
            { Render ? <div className="X fixed"><A onClick={()=>{
                setRender(null);
                setPage(null);
            }}>X</A></div> : null}
        <div className="middle">
            { Render ? <Render/> : <div className="menu">
                <Logo/>
                <div className="ul">
                    <ul>
                        {page?pages.find(p=>p[0]==page)[1]?.map((p,i)=><li key={i}><A onClick={()=>setRender(() => p[1])}>{p[0]}</A></li>):pages.map((p,i)=><li key={i}><A onClick={()=>setPage(p[0])}>{p[0]}</A></li>)}
                        {page ? <li className="back"><i><A onClick={()=>setPage(null)}>Back...</A></i></li> : null}
                    </ul>
                </div>
            </div>}
        </div>
    </div>
}

export default Kaipad;